import CrudRequest from '@rootCommon/services/crud-request';
import { ORGANIZATION } from '@rootCommon/constants/end-points';
import { Organization, OrganizationDto } from '@rootCommon/types/organization';
import { ADMIN } from '@rootCommon/constants/common';

const ORGANIZATION_ADMIN = `${ORGANIZATION}/${ADMIN}`;
const ORGANIZATION_TITLE = `${ORGANIZATION}/${'title'}`;

class OrganizationService extends CrudRequest<Organization, OrganizationDto> {
  constructor() {
    super(ORGANIZATION_ADMIN);
  }

  getItem = async (): Promise<Organization> => {
    const res = await CrudRequest.get<Organization>(ORGANIZATION_ADMIN);

    return res.data;
  };

  updateItem = async (organization: OrganizationDto): Promise<Organization> => {
    const res = await CrudRequest.put<Organization, OrganizationDto>(ORGANIZATION_ADMIN, organization);

    return res.data;
  };

  getTitle = async (): Promise<Pick<OrganizationDto, 'title'>> => {
    const res = await CrudRequest.get<Pick<OrganizationDto, 'title'>>(ORGANIZATION_TITLE);

    return res.data;
  };
}

export default new OrganizationService();
